export const USER = 'user'
export const SET_USER_DATA = USER + '/SET_USER_DATA'
export const SET_USER_ROLE = USER + '/SET_ROLE'
export const SET_HAS_MENTOR_ACCOUNT = USER + '/SET_HAS_MENTOR_ACCOUNT'
export const SET_HAS_MENTEE_ACCOUNT = USER + '/SET_HAS_MENTEE_ACCOUNT'
export const SET_HAS_ADMIN_ACCOUNT = USER + '/SET_HAS_ADMIN_ACCOUNT'
export const SET_AUTHENTICATION_CHECK_DONE = USER + '/SET_AUTHENTICATION_CHECK_DONE'